var _linearGradient, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebHosting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 45,
    viewBox: "0 0 44 45",
    width: 44,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 12.3651,
    x2: 43.5472,
    y1: 34.9857,
    y2: 8.67604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4312a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25638,
    stopColor: "#6233df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#849bff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.1 11h-13.8c-.6098.0008-1.1943.2433-1.6255.6745s-.6737 1.0157-.6745 1.6255v18.4c.0008.6098.2433 1.1943.6745 1.6255s1.0157.6737 1.6255.6745h13.8c.6098-.0008 1.1943-.2433 1.6255-.6745s.6737-1.0157.6745-1.6255v-18.4c-.0008-.6098-.2433-1.1943-.6745-1.6255s-1.0157-.6737-1.6255-.6745zm-10.35 19.55h-2.3v-2.3h2.3zm0-4.6h-2.3v-2.3h2.3zm0-4.6h-2.3v-2.3h2.3zm9.2 9.2h-6.9v-2.3h6.9zm0-4.6h-6.9v-2.3h6.9zm0-4.6h-6.9v-2.3h6.9zm0-4.6h-6.9v-2.3h6.9zm-9.2 0h-2.3v-2.3h2.3z",
    fill: "url(#a)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebHosting);
export default __webpack_public_path__ + "static/media/web-hosting.70f7502149bf8171cb4ea7e3dfd166e4.svg";
export { ForwardRef as ReactComponent };